module.exports = __webpack_public_path__ + "static/media/rs.f1db11a2.svg";